import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

export function ReCaptchaTerms({ sx, ...other }) {
  const { t } = useTranslate();

  return (
    <Typography
      component="div"
      sx={[
        { textAlign: 'start', typography: 'caption', color: 'text.secondary' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {`${t('This site is protected by reCAPTCHA and the Google, the')} `}
      <Link target="_blank" color="text.primary" href="https://policies.google.com/terms">
        {t('Terms of service')}
      </Link>
      {t(' and ')}
      <Link target="_blank" color="text.primary" href="https://policies.google.com/privacy">
        {t('Privacy policy')}
      </Link>
      {t(' will apply')}.
    </Typography>
  );
}
